import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IResponse } from '~/types/repositories';
import type {
  IAuthCurrentResponse,
  TAuthLoginParams, IAuthLoginResponse,
  TAuthRegisterParams,
  IAuthRegisterResponse, IAuthForgotPasswordParams, IAuthForgotPasswordResponse,
  IAuthResetPasswordParams, IAuthPhoneCheckResponse,
} from '~/modules/auth/types/auth';

export default class Auth extends AbstractFetch {
  private static readonly REGISTER = 'v1/auth/register';
  private static readonly CURRENT = 'v1/auth/me';
  private static readonly LOGIN = 'v1/auth/login';
  private static readonly LOGOUT = 'v1/auth/logout';
  private static readonly PHONE_CHECK = 'v1/phones/check/';
  private static readonly PHONE_SEND = 'v1/phones/send/';
  private static readonly FORGOT_PASSWORD = 'v1/auth/forgot-password';
  private static readonly RESET_PASSWORD = 'v1/auth/reset-password';

  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  async login(params: TAuthLoginParams): Promise<IResponse<IAuthLoginResponse>> {
    return this.fetch(Auth.LOGIN, {
      method: 'POST',
      body: params,
    });
  }

  async register(params: TAuthRegisterParams): Promise<IResponse<IAuthRegisterResponse>> {
    return this.fetch(Auth.REGISTER, {
      method: 'POST',
      body: params,
    });
  }

  async forgotPassword(params: IAuthForgotPasswordParams): Promise<IResponse<IAuthForgotPasswordResponse>> {
    return this.fetch(Auth.FORGOT_PASSWORD, {
      method: 'POST',
      body: params,
    });
  }

  async resetPassword(params: IAuthForgotPasswordParams): Promise<IResponse<IAuthForgotPasswordResponse>> {
    return this.fetch(Auth.RESET_PASSWORD, {
      method: 'POST',
      body: params,
    });
  }

  async current(): Promise<IResponse<IAuthCurrentResponse>> {
    return this.fetch(Auth.CURRENT, {
      method: 'GET',
    });
  }

  async logout(): Promise<IResponse<void>> {
    return this.fetch(Auth.LOGOUT, {
      method: 'POST',
    });
  }

  async checkPhone(phone: string): Promise<IResponse<IAuthPhoneCheckResponse>> {
    return this.fetch(Auth.PHONE_CHECK + phone, {
      method: 'GET',
    });
  }

  async sendSMS(phone: string): Promise<IResponse<void>> {
    return this.fetch(Auth.PHONE_SEND, {
      method: 'POST',
      body: { phone }
    });
  }
}
